var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticStyle:{"margin-top":"40px","padding-bottom":"20px"}},[_c('store-detail',{staticStyle:{"margin-bottom":"20px"}}),_c('shipping-label-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }